import {bleManager} from '../ble2/v2/BleManager';

export const getIsPup = (connected = false) => {
  if (!connected) return false;

  return bleManager.otaDevice?.deviceState === 'pupApp';
};
